/**
 * Single `appUrlOpen` dispatcher shared by every deep-link consumer.
 *
 * A URL that arrives before JS is listening (cold launch via a deep link or the
 * "Add entry" quick action) is held natively and replayed to the FIRST
 * `appUrlOpen` listener only. With one listener per feature, whichever module
 * registered second silently missed cold-launch URLs. Registering exactly one
 * listener that fans out to every handler makes delivery independent of
 * registration order.
 *
 * Callers self-gate on native before registering, so this module does not.
 */
import { App, type URLOpenListenerEvent } from '@capacitor/app';

type UrlOpenHandler = (event: URLOpenListenerEvent) => void;

const handlers: UrlOpenHandler[] = [];
let listening = false;

export function onAppUrlOpen(handler: UrlOpenHandler): void {
  handlers.push(handler);
  if (listening) return;
  listening = true;
  void App.addListener('appUrlOpen', (event) => {
    for (const h of handlers) h(event);
  });
}
